// npm
import React, { Component } from "react";
import { connect } from "react-redux";
import { withMessages } from "components/hocs/messages";

// react (layout)
import { Align } from "components/layout/align";
import Button from "@material-ui/core/Button";

// react (concrete)
import { AppPageModifier } from "components/pages/app-page-modifier";

// redux (selectors)
import { getGuid } from "redux/reducers/exam/selectors";
import { getExamData, getSchedulesData } from "redux/reducers/selectors";

import { getScheduleDataByExamGuid } from "redux/reducers/schedules/selectors";
import { getProctorProvider } from "redux/reducers/schedules/schedule/selectors";

import { PROCTORING_TYPES } from "constants/proctoring";
import { MESSAGE_IDS } from "constants/message-ids";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import withStyles from "@material-ui/core/styles/withStyles";
import { MaterialText } from "components/presentation/material-text";
import { isValidMessage } from "./integrity-advocate-helper";

// GuidanceIntegrityAdvocate (not connected to store)
// -----------------------------------------------------------------

class GuidanceIntegrityAdvocate extends Component {
    state = {};
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const { isIntegrityAdvocate, onNotIntegrityAdvocate, messages, onIntegrityAdvocate } = this.props;
        const message = messages[MESSAGE_IDS.EXAM.INTEGRITY_ADVOCATE_GUIDANCE];

        if (!isIntegrityAdvocate) {
            onNotIntegrityAdvocate();
        }
        else if (!isValidMessage(message)) {
            onIntegrityAdvocate();
        }
    }

    handleClick() {
        const { onIntegrityAdvocate } = this.props;
        onIntegrityAdvocate();
    }

    render() {
        const { isIntegrityAdvocate, messages, classes } = this.props;
        const message = messages[MESSAGE_IDS.EXAM.INTEGRITY_ADVOCATE_GUIDANCE];

        if (!isIntegrityAdvocate || !message) {
            return null;
        }

        const title = "Integrity Advocate Check";

        return (
            <React.Fragment>
                <AppPageModifier
                    id="pdf-checker"
                    appBarProps={{ loading: false, title, logout: false }}
                />
                <Align top>
                    <Card className={classes.panel}>
                        <CardContent>
                            <MaterialText className={classes.text}>
                                {message}
                            </MaterialText>
                        </CardContent>
                        <CardActions style={{justifyContent:"flex-end"}}>
                            <Button
                                onClick={this.handleClick}
                                variant="contained"
                                color="primary"
                            >
                                Continue
                            </Button>
                        </CardActions>
                    </Card>
                </Align>
            </React.Fragment>
        );
    }
}

// GuidanceIntegrityAdvocate (connected to store)
// -----------------------------------------------------------------

const styles = ({ palette, spacing, breakpoints }) => ({
    text: {
        color: palette.background.contrastText,
    },
    panel: {
        backgroundColor: palette.background.light,
        //maxWidth: 800,
        [breakpoints.down(840)]: {
            width: "calc(100% - 40px)",
            marginLeft: 20,
            marginRight: 20,
        },
        [breakpoints.up(841)]: {
            width: 800,
        },
        marginTop: spacing.unit * 2,
        // alignSelf: "stretch",
    },
});

GuidanceIntegrityAdvocate = withMessages(
    withStyles(styles)(GuidanceIntegrityAdvocate)
);

const mapStoreToProps = (store) => {
    const examData = getExamData(store);
    const examGuid = getGuid(examData);

    const schedulesData = getSchedulesData(store);
    const scheduleData = getScheduleDataByExamGuid(schedulesData)(examGuid);
    const proctoringProvider = getProctorProvider(scheduleData);

    return {
        isIntegrityAdvocate:
            proctoringProvider === PROCTORING_TYPES.INTEGRITY_ADVOCATE,
        // isIntegrityAdvocate: true,
    };
};

GuidanceIntegrityAdvocate = connect(mapStoreToProps)(GuidanceIntegrityAdvocate);

// GuidanceIntegrityAdvocate (EXPORT)
// -----------------------------------------------------------------
export { GuidanceIntegrityAdvocate };
